import { IPublicClientApplication } from "@azure/msal-browser";

import {
    axiosDelRequest,
    axiosGetRequest,
    axiosPostRequest,
    axiosPutRequest,
} from "../../api/ApiClient";
import Cartao from "../../model/dto/Cartao";
import Justificativa from "../../model/dto/Justificativa";
import CartaoParams from "../../model/params/CartaoParams";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";

const route = "/docente/v1/cartoes";
const routeAgenda = "docente/v1/agendas/atividades-esporadicas";
const routerprofessores = "docente/v1/professores";

async function getCartoes(
    msalInstance: IPublicClientApplication,
    cartaoParams: CartaoParams
) {
    const params = StringUtils.getQueryParams(cartaoParams);

    return axiosGetRequest(
        `${route}${params}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getCartoesUltimaVigencia(
    msalInstance: IPublicClientApplication,
    cartaoParams: CartaoParams
) {
    const params = StringUtils.getQueryParams(cartaoParams);

    return axiosGetRequest(
        `${routeAgenda}${params}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getCartoesAtividade(
    msalInstance: IPublicClientApplication,
    docente: string
) {
    return axiosGetRequest(
        `${routerprofessores}/${docente}/atividades`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getById(
    msalInstance: IPublicClientApplication,
    cartaoAgendaId: number
) {
    return axiosGetRequest(
        `${route}/${cartaoAgendaId}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function salvarCartao(
    msalInstance: IPublicClientApplication,
    cartao: Cartao
) {
    return axiosPostRequest(
        `${route}`,
        cartao,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function editarCartao(
    msalInstance: IPublicClientApplication,
    cartao: Cartao
) {
    return axiosPutRequest(
        `${route}/${cartao.cartaoAgendaId}`,
        cartao,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

function deletarCartao(instance: IPublicClientApplication, cartaoId: number) {
    return axiosDelRequest(
        `${route}/${cartaoId}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function deletarCartaoJustificado(
    msalInstance: IPublicClientApplication,
    cartaoId: number,
    data: object
) {
    return axiosPostRequest(
        `${route}/${cartaoId}/exclusaohoraextra`,
        data,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function justificativaCartao(
    msalInstance: IPublicClientApplication,
    cartaoAgendaId: number,
    justificativa: Justificativa
) {
    return axiosPostRequest(
        `${route}/${cartaoAgendaId}/justificativa`,
        justificativa,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function setAlocacaoHoraExtra(
    msalInstance: IPublicClientApplication,
    cartaoHoraExtraId: number,
    cartoesAfetados: Array<number>
) {
    return axiosPutRequest(
        `${route}/${cartaoHoraExtraId}/alocacaoHoraExtra`,
        cartoesAfetados,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getJustificationDate(
    msalInstance: IPublicClientApplication,
    cartaoId: number
) {
    return axiosGetRequest(
        `${route}/${cartaoId}/validadatajustificativa`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getSporadicActivitiesByCardId(
    msalInstance: IPublicClientApplication,
    cardId: number
) {
    return axiosGetRequest(
        `${route}/${cardId}/atividadesesporadicas`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getCardLastStatusFromBackend(
    msalInstance: IPublicClientApplication,
    cardId: number
) {
    return axiosGetRequest(
        `${route}/${cardId}/statusanterior`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

export default {
    getCartoes,
    getById,
    salvarCartao,
    editarCartao,
    deletarCartao,
    deletarCartaoJustificado,
    justificativaCartao,
    getCartoesUltimaVigencia,
    getCartoesAtividade,
    setAlocacaoHoraExtra,
    getJustificationDate,
    getSporadicActivitiesByCardId,
    getCardLastStatusFromBackend,
};
